var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,6h-3V2c0-1.1025391-0.8974609-2-2-2H10C8.8974609,0,8,0.8974609,8,2v4H5C3.3457031,6,2,7.3457031,2,9v12 c0,1.6542969,1.3457031,3,3,3h3v6c0,1.1025391,0.8974609,2,2,2h12c1.1025391,0,2-0.8974609,2-2v-6h3c1.6542969,0,3-1.3457031,3-3V9 C30,7.3457031,28.6542969,6,27,6z M10,2h12v4H10V2z M22,30H10V20h12V30z M28,21c0,0.5517578-0.4482422,1-1,1h-3v-2h2v-2h-2H8H6v2h2 v2H5c-0.5517578,0-1-0.4482422-1-1V9c0-0.5517578,0.4482422-1,1-1h3h16h3c0.5517578,0,1,0.4482422,1,1V21z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 8,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintSmall);
export default __webpack_public_path__ + "static/media/print--small.a56c2a6d157afceadb32c8c661f5a7f5.svg";
export { ForwardRef as ReactComponent };